import apiClient from '../utils/apiClient';

const alarm = '/alarm';
const tag = '/tag';

// API hatalarını işleyen yardımcı fonksiyon
const handleApiError = (error, defaultMessage) => {
  console.error(defaultMessage, error);
  throw error;
};

// 🔹 Alarm Ayarlarını Getir
export const GetAllAlarmSettings = async () => {
  try {
    const response = await apiClient.get(`alarm/settings`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch alarm settings.');
  }
};

// 🔹 Alarm Geçmişini Uygula
// export const applyAlarmHistory = async (start, end, alarmIds) => {
//   try {
//     const response = await apiClient.post(`/Alarm/History`, {
//       start,
//       end,
//       alarm_ids: alarmIds,
//     });
//     return response.data;
//   } catch (error) {
//     handleApiError(error, 'Failed to fetch alarm history.');
//   }
// };

// 🔹 Cihaz ve Tag Listesini Getir
export const GetAllDeviceListWithTags = async () => {
  try {
    const response = await apiClient.get(`tag/tagList`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch device tags.');
  }
};

// 🔹 Veri Tiplerini Getir
export const GetAllDataTypes = async () => {
  try {
    const response = await apiClient.get(`/DataTypes/GetAll`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch data types.');
  }
};

// 🔹 Alarm Gruplarını Getir
export const GetAlarmGroup = async () => {
  try {
    const response = await apiClient.get(`alarm/AlarmGroups`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch alarm groups.');
  }
};

// 🔹 Tüm Alarmları Getir
export const GetAllAlarms = async () => {
  try {
    const response = await apiClient.get(`alarm/Display`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch alarms.');
  }
};

// 🔹 ID'ye Göre Alarm Getir
export const getAlarmById = async alarmId => {
  try {
    const response = await apiClient.get(`alarm/?id=${alarmId}`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch alarm details.');
  }
};

// 🔹 Alarm Güncelle
export const updateAlarm = async (id, alarm) => {
  try {
    const response = await apiClient.put(`alarm/?id=${id}`, alarm);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to update alarm.');
  }
};

// 🔹 Yeni Alarm Oluştur
export const createAlarm = async alarm => {
  try {
    const response = await apiClient.post(`alarm`, alarm);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to create alarm.');
  }
};

// 🔹 Alarm Tag Güncelle
export const updateAlarmTag = async ({ alarmId, IdOrValue, ref_type }) => {
  try {
    const response = await apiClient.put(`alarm/setReferange?id=${alarmId}`, {
      IdOrValue,
      ref_type,
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to update alarm tag.');
  }
};

// 🔹 Alarm Sil
export const deleteAlarm = async id => {
  try {
    const response = await apiClient.delete(`alarm/?id=${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to delete alarm.');
  }
};

// 🔹 Yeni Alarm Grubu Oluştur
export const createAlarmGroup = async group => {
  try {
    const response = await apiClient.post(`/Alarm/Group`, group);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to create alarm group.');
  }
};

// 🔹 Alarm Grubu Sil
export const deleteAlarmGroup = async id => {
  try {
    const response = await apiClient.delete(`/Alarm/Group?id=${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to delete alarm group.');
  }
};

// 🔹 Alarm Grubu Güncelle
export const updateAlarmGroup = async ({ id, group }) => {
  try {
    const response = await apiClient.put(`/Alarm/Group?id=${id}`, group);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to update alarm group.');
  }
};

// 🔹 Alarmları Excel Olarak Dışa Aktar
export const exportAlarmsToExcel = async () => {
  try {
    const response = await apiClient.get(`/alarm/exportExcel`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to export alarms.');
  }
};

export const applyAlarmHistory = async (
  start,
  end,
  alarmIds,
  pageNumber = 1,
  pageSize = 100
) => {
  try {
    const response = await apiClient.post(`/Alarm/History`, {
      start,
      end,
      alarm_ids: alarmIds,
      pageNumber,
      pageSize,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const fetchGroupWithAlarms = async () => {
  try {
    const response = await apiClient.get(`/Alarm/groupWithAlarm`);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const downloadAlarmReport = async (start, end, alarm_ids, fileType) => {
  try {
    const response = await apiClient.post(
      `/Alarm/GetExcelReport?type=${fileType}`,
      {
        start,
        end,
        alarm_ids,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob',
      }
    );

    const blob = new Blob([response.data], {
      type: response.headers['content-type'],
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `alarm_report.${fileType}`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (error) {
    console.error('Error downloading report:', error);
  }
};
